/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './KeyValuePie.css';

import CustomChart from '../../../components/CustomChart/CustomChart'
import { CustomizedForm } from '../components/baseForm'
import baseFiled from '../components/baseFiled';
import DataPanel from '../components/KeyValuePie'
import { isArray } from 'util';
import { createKeyWordChart } from './scatter';

// @ts-ignore
import cognitivekeywords from './cognitivekeywords.json'

const checkPx = (str) => {
  let _str = str + '';
  if (_str.indexOf('%')) {
    return _str;
  } else {
    return _str + 'px'
  }
}

class KeyValuePie extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      fields: {
        // ...baseFiled,
        ...Object.assign(baseFiled, {
          titleText: {
            value: ''
          },
          subTitleText: {
            value: ''
          }
        })
      },
      data: {
        ...cognitivekeywords,
        floor: 4,
        fontSizes: [20, 18, 16, 14]
      },
      colorList: [
        ['#dc8a03', '#f19601', '#f7ba5f', '#fcddb1'],
        ['#850609', '#9e0307', '#bc3e41', '#d77d7f'],
        ['#a44c34', '#c55d42', '#ec754d', '#f6bda2'],
        ['#f0e301', '#fff001', '#fff46c', '#fff9bf'],
        ['#a44c34', '#c55d42', '#ec754d', '#f6bda2'],
      ],
      chartWidth: '100%',
      chartHeight: '100%',
    }
  }

  handleFormChange = (props, changedFields) => {
    this.setState(({ fields }) => ({
      fields: {
        ...fields,
        ...changedFields
      }
    }));
  }

  handleAdd = (props, changedFields) => {
    if (isArray(changedFields)) {
      this.setState({
        data: {
          ...changedFields[0]
        }
      })
    } else {
      this.setState({
        data: changedFields
      })
    }
  }

  handleClick = () => {
    const {fields} = this.state;
    this.setState({
      chartHeight: checkPx(fields.chartHeight.value),
      chartWidth: checkPx(fields.chartWidth.value),
    })
  }

  render() {
    const {fields, colorList, chartWidth, chartHeight, beginTime, endTime, data} = this.state;

    let _data = JSON.parse(JSON.stringify(data))
    _data.list.forEach(element => {
      element.forEach(item => {
        item.name = item.name.replace(/\/s/g, ' ')
        item.name = item.name.replace(/\/n/g, '\n')
        // if(item.name.length > 8 || item.name.length == 8) {
        //   item.name = item.name.slice(0, 4) + "\n" + item.name.slice(4);
        //   console.log(item.name)
        // }
      })
    });
    _data.colorList = colorList
    
    const option = {
      ...createKeyWordChart(_data),
      clear: true,
    }
    option.title = {
      text: fields.titleText.value,
      textStyle: {
        color: fields.titleColor.value,
        fontWeight: fields.titleWeight.value,
        fontSize: fields.titleSize.value
      },
      subtextStyle: {
        color: fields.subTitleColor.value,
        fontWeight: fields.subTitleWeight.value,
        fontSize: fields.subTitleSize.value,
        lineHeight: 20
      },
      top: 0,
      left: 50,
      subtext: fields.subTitleText.value,
    }

    return (
      <CustomChart 
        width={chartWidth}
        height={chartHeight}
        chart={option} 
        callback={this.handleClick}
      >
        <DataPanel
          beginTime={beginTime}
          endTIme={endTime}
          color={colorList}
          onChange={this.handleAdd}
          data={data}
        />
        <CustomizedForm {...fields} onChange={this.handleFormChange} />
      </CustomChart>
    );
  }
}

export default withStyles(s)(KeyValuePie);



// WEBPACK FOOTER //
// src/routes/customChart/KeyValuePie/KeyValuePie.js